import React from "react";
import styled from "styled-components";
import { GlassCard } from "../../../../ui";

export const FleetSummaryCard = ({ summary, loading }) => {
  const value = (n) => (loading || n === undefined || n === null ? "—" : n.toLocaleString());

  return (
    <Row>
      <Kpi>
        <Label>Reporting</Label>
        <Value tone="green">{value(summary?.reporting)}</Value>
        <Sub>last 60 min</Sub>
      </Kpi>
      <Kpi>
        <Label>Stale</Label>
        <Value tone="amber">{value(summary?.stale)}</Value>
        <Sub>1–6h since last</Sub>
      </Kpi>
      <Kpi>
        <Label>Errored</Label>
        <Value tone="red">{value(summary?.errored)}</Value>
        <Sub>latest status = error</Sub>
      </Kpi>
      <Kpi>
        <Label>Rows ingested (24h)</Label>
        <Value>{value(summary?.rows_24h)}</Value>
        <Sub>across all boxes</Sub>
      </Kpi>
    </Row>
  );
};

const Row = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0.75rem;
  margin-bottom: 1.25rem;
  @media (max-width: 768px) { grid-template-columns: repeat(2, 1fr); }
`;

const Kpi = styled(GlassCard)`
  padding: 0.85rem 1rem;
`;

const Label = styled.div`
  font-size: 0.7rem;
  font-weight: 600;
  color: rgba(0,0,0,0.6);
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

const Value = styled.div`
  font-size: 1.6rem;
  font-weight: 700;
  margin-top: 0.2rem;
  color: ${({ tone }) =>
    tone === "green" ? "#10b981" :
    tone === "amber" ? "#f59e0b" :
    tone === "red"   ? "#ef4444" : "rgba(0,0,0,0.9)"};
`;

const Sub = styled.div`
  font-size: 0.7rem;
  color: rgba(0,0,0,0.5);
  margin-top: 0.2rem;
`;
